<template>
  <div v-if="list.length > 0">
    <div class="text-xl font-bold text-text leading-tight mb-4">{{ $t('listTitle') }}</div>
    <div class="invites-grid invites-grid--header">
      <div>{{ $t('mailLabel') }}</div>
      <div>{{ $t('roleLabel') }}</div>
    </div>
    <div class="divide-y divide-border">
      <div v-for="(item,i) in list" :key="i" class="invites-grid invites-grid--item group">
        <div class="truncate">{{ item.email || item.login }}</div>
        <div>{{ userRole(item.role) }}</div>

        <div v-if="currentUserIsAdmin" class="flex space-x-4 justify-end">
          <div class="icon-btn"
               v-tooltip="{content: $t('resendInvite'), classes: '--white role-tooltip-popover'}"
               @click="resend(item.id)">
            <IconRefresh/>
          </div>
          <div class="icon-btn"
               @click="deleteInviteItem(item.id)">
            <IconTrash/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import IconRoundTick from "@/components/icons/IconRoundTick";
import IconTrash from "@/components/icons/IconTrash";
import IconRefresh from "@/components/icons/IconRefresh";

export default {
  name: "AccessInvitesList",
  components: {IconRefresh, IconTrash, IconRoundTick},
  data() {
    return {
      submitted: false
    }
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ...mapGetters('space', ['currentUserIsAdmin']),
  },
  methods: {
    ...mapActions('space/access', ['resendInvite', 'deleteInvite']),
    ...mapActions('cabinet/invitations', ['getSentInvitations']),
    userRole(role_id) {
      return this.getConstantList('member_role').find(item => +item.id === role_id).name
    },
    async resend(id) {
      if (this.submitted) return;
      try {
        this.submitted = true;
        const res = await this.resendInvite(id);
        if (res.data.success) {
          this.$toasted.success('Приглашение отправлено!')
          this.getSentInvitations();
        } else {
          this.$toasted.error(this.$t('errors.response'))
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error(this.$t('errors.response'))
      } finally {
        this.submitted = false;
      }
    },
    async deleteInviteItem(id) {
      if (this.submitted) return;
      try {
        this.submitted = true;
        const res = await this.deleteInvite(id);
        if (res.data.success) {
          this.$toasted.success('Приглашение удалено!')
          this.getSentInvitations();
        } else {
          this.$toasted.error(this.$t('errors.response'))
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error(this.$t('errors.response'))
      } finally {
        this.submitted = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Invitations',
        mailLabel: 'Email',
        roleLabel: 'Role',
        resend: 'Resend e-mail invite',
        invitationSent: 'Invitation has been sent',
        invitationDeleted: 'Invitation deleted',
        resendInvite: 'Resend invite'
      },
      ru: {
        listTitle: 'Приглашения',
        mailLabel: 'Почта',
        roleLabel: 'Роль',
        resend: 'Отправить письмо повторно',
        invitationSent: 'Приглашение отправлено',
        invitationDeleted: 'Приглашение удалено',
        resendInvite: 'Отправить повторно'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invites-grid {
  @apply grid col-gap-8 py-4 items-center
  text-sm text-text-secondary font-medium;
  grid-template-columns: 40% 30% auto;

  &--header {
    @apply text-sm text-text-ternary;
  }

  &--item {
    .icon-btn {
      @apply flex items-center justify-center text-text-ternary
      border border-border rounded transition duration-200 cursor-pointer;
      width: 26px;
      height: 26px;


      &:hover {
        @apply bg-red-hover text-white border-red-hover;
      }
    }
  }
}
</style>
